import React, {createContext, useContext, useEffect, useRef} from 'react'
import PropTypes from 'prop-types'
import useCustomPreferencesListQuery from '../custom-hooks/use-custom-preferences-list'

export const CustomPreferencesContext = createContext()

export const CustomPreferencesProvider = ({children}) => {
    const customPreferences = useRef()
    const {data, isError, isLoading} = useCustomPreferencesListQuery()

    useEffect(() => {
        if (data || !isError) customPreferences.current = data
    }, [isLoading, data])

    return (
        <CustomPreferencesContext.Provider value={customPreferences.current?.data || []}>
            {children}
        </CustomPreferencesContext.Provider>
    )
}

CustomPreferencesProvider.propTypes = {
    children: PropTypes.node.isRequired,
}

export const useCustomPreferences = () => {
    const context = useContext(CustomPreferencesContext)
    if (!context) {
        throw new Error('useCustomPreferences must be used within a CustomPreferencesProvider')
    }
    return context
}
